import { render, staticRenderFns } from "./UserProfileData.vue?vue&type=template&id=dbba8cec"
import script from "./UserProfileData.vue?vue&type=script&lang=js"
export * from "./UserProfileData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports